import { render, staticRenderFns } from "./ProfileDropDown.vue?vue&type=template&id=5b13e317&scoped=true"
import script from "./ProfileDropDown.vue?vue&type=script&lang=js"
export * from "./ProfileDropDown.vue?vue&type=script&lang=js"
import style0 from "./ProfileDropDown.vue?vue&type=style&index=0&id=5b13e317&prod&lang=scss&scoped=true"
import style1 from "./ProfileDropDown.vue?vue&type=style&index=1&id=5b13e317&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b13e317",
  null
  
)

export default component.exports